module.exports = __webpack_public_path__ + "static/media/GreenArrow.7c94b344.svg";